import * as Sentry from "@sentry/react"
import { setUseWhatChange } from "@simbathesailor/use-what-changed"
import { broadcastQueryClient } from "@tanstack/query-broadcast-client-experimental"
import { QueryClientProvider } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import { RouterProvider } from "react-router-dom"

import { client } from "@l2r-front/l2r-query"
import { CssBaseline, GlobalStyles, globalStyles } from "@l2r-front/l2r-ui"

import "./app.css"
import { router } from "./common/routers/AppRouter"
import "./i18n"

broadcastQueryClient({
    queryClient: client,
    broadcastChannel: "l2r-services",
})

const sentryDNS = process.env["NX_PUBLIC_SENTRY_DSN"]
if (sentryDNS) {
    let environment = {}
    environment.name = process.env["NX_PUBLIC_ENVIRONMENT"] || ""
    environment.type = environment.name

    // We don't want an env per specific sandbox
    //  sandbox NX_PUBLIC_ENVIRONMENT looks like: sandbox-788e55063e754446jf19ee1fe511f0365c3e2c76
    if (environment.name.startsWith("sandbox-")) {
        environment.type = "sandbox"
    }

    // eslint-disable-next-line no-console
    console.log(`NX_PUBLIC_RELEASE_VERSION : ${process.env["NX_PUBLIC_RELEASE_VERSION"]}`)

    Sentry.init({
        dsn: sentryDNS,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration({
                maskAllText: false,
                blockAllMedia: false,
                maskAllInputs: false,
            }),
        ],
        debug: false,
        tracesSampleRate: 1.0,
        environment: environment.type,
        release: process.env["NX_PUBLIC_RELEASE_VERSION"],
        replaysSessionSampleRate: Number(process.env["NX_PUBLIC_SENTRY_REPLAY_RATE"]) || 0,
        replaysOnErrorSampleRate: 1.0,
    })

    Sentry.setTag("environment_name", environment.name)
}

setUseWhatChange(process.env.NODE_ENV === "development")

window.addEventListener("unload", () => {
    if (window.opener) {
        window.opener.postMessage("childWindowClosed", process.env["NX_PUBLIC_FRONT_L2R"])
    }
})


export function App() {

    return (
        <QueryClientProvider client={client}>
            <ReactQueryDevtools initialIsOpen={false} />
            <CssBaseline />
            <GlobalStyles styles={globalStyles} />
            <RouterProvider router={router} />
        </QueryClientProvider>
    )
}
